import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
} from 'actions/actionConstants'
import {
  FETCH_SPOOF_LAUNCHPAD_OFFER_VIEWS,
  FETCH_SPOOF_USER_CARTS,
  USER_LOGOUT,
} from 'actions/apiActionConstants'
import { apiReducerSwitch, createAppReducer } from 'lib/redux/reducerUtils'

export const initialAiOpsState: App.AiOpsState = {
  userCarts: {
    carts: [],
    state: 'initial',
  },
  offerViews: {
    offers: [],
    state: 'initial',
  },
}

const apiCalls = apiReducerSwitch<App.AiOpsState>({
  [FETCH_SPOOF_USER_CARTS]: {
    request: (_, action) => ({
      userCarts: {
        carts: [],
        state: 'loading',
        error: undefined,
        cacheKey: action.cacheKey,
      },
    }),
    success: (_, action) => ({
      userCarts: {
        carts: action.data.carts,
        state: 'done',
        error: undefined,
        cacheKey: action.cacheKey,
      },
    }),
    failure: (_, action) => ({
      userCarts: {
        carts: [],
        state: 'error',
        error: action.error,
        cacheKey: action.cacheKey,
      },
    }),
  },
  [FETCH_SPOOF_LAUNCHPAD_OFFER_VIEWS]: {
    request: (_, action) => ({
      offerViews: {
        offers: [],
        state: 'loading',
        error: undefined,
        cacheKey: action.cacheKey,
      },
    }),
    success: (_, action) => ({
      offerViews: {
        offers: action.data,
        state: 'done',
        error: undefined,
        cacheKey: action.cacheKey,
      },
    }),
    failure: (_, action) => ({
      offerViews: {
        offers: [],
        state: 'error',
        error: action.error,
        cacheKey: action.cacheKey,
      },
    }),
  },
  [USER_LOGOUT]: {
    success: () => initialAiOpsState,
  },
})

const aiOpsReducer = createAppReducer<App.AiOpsState>(initialAiOpsState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
})

export default aiOpsReducer
